export default __webpack_public_path__ + "static/media/icon-play.cb872aa1.svg";